import styled from 'styled-components';

export const ScheduleOptionsContainer = styled.div`
  padding-block: var(--spacement-medium);
`

export const ScheduleOption = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-inline: var(--spacement-xxlarge);
  padding-block: var(--spacement-default);
  cursor: pointer;
  transition: background 0.2s;
  font-size: var(--font-size-default);
  &:hover {
    background: var(--primary-100-light);
  }
`;

export const ModalDescription = styled.div`
  font-size: var(--font-size-default);
  padding-inline: var(--spacement-xxlarge);
`
